import { useMemo } from 'react';
import { UseQueryOptions, useQuery } from 'react-query';
import { ProjectId } from 'api/models';
import { Project, ProjectAPI } from 'api/project';
import { ProjectInUserProfile } from 'api/user';
import { useProjectsFromInitData } from 'queries/account';
import { ApiErrorData } from 'queries/error';
import { useProjectDetailQuery } from 'queries/project';

export const useProjectDetail = (
  projectId: ProjectId,
  options: UseQueryOptions<Project, ApiErrorData, Project, ProjectId> = {},
) => {
  return useProjectDetailQuery(projectId, {
    ...options,
    retry: 1,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    enabled: typeof projectId?.[1] === 'number',
  });
};

export const useProject = ([, id]: ProjectId):
  | Pick<ProjectInUserProfile, 'projectId' | 'projectName'>
  | undefined => {
  const { data } = useProjectsFromInitData();

  return useMemo(() => data?.byId[id], [data?.byId, id]);
};

export const useGetProjectMembers = (projectId: number) => {
  return useQuery(['project-members', projectId], () =>
    ProjectAPI.getProjectMembers(projectId),
  );
};
